import { RegEx } from "/imports/api/_jsonSchemas/schemas/components/_all";

export const signupSchema = {
  $id: "schemas/signupSchema",
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    company: { type: "string" },
    type: { type: "string", enum: ["shipper", "carrier"] },
    first: { type: "string" },
    last: { type: "string" },
    email: {
      type: "string",
      pattern: RegEx.Email.source
    },
  },
  required: ["company", "type", "first", "last", "email"],
  errorMessage:{
    required: "Required field",
  }
}